<template>
  <div>
    <section class="section-block">
      <div class="container">
        <section-title
          kicker="Về chúng tôi"
          :title="companyInfo.companyName || 'Công ty TNHH NWM Việt Nam'"
          :description="companyInfo.description || 'Đội ngũ chuyên về bảo trì và tối ưu hệ thống nước cho doanh nghiệp.'"
        />
        <div class="row">
          <div class="col-lg-7 mb-4 mb-lg-0">
            <div class="section-card p-4 p-lg-5 h-100">
              <h3 class="font-weight-bold text-primary mb-4">Tư duy vận hành chuẩn xác, linh hoạt theo hiện trạng</h3>
              <p class="section-copy">
                Công ty TNHH NWM Việt Nam tập trung vào sự ổn định, khả năng phản hồi nhanh và giải pháp thiết thực cho từng hệ thống.
                Chúng tôi đồng hành từ giai đoạn khảo sát, lập kế hoạch bảo trì đến theo dõi chất lượng vận hành.
              </p>
              <p class="section-copy mb-0">
                Với chủ đề thương hiệu gắn với nước sạch và sự bền vững, website được xây dựng để giúp khách hàng dễ tiếp cận thông tin,
                gửi yêu cầu tư vấn và cập nhật tin tức chuyên môn.
              </p>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="section-card p-4 p-lg-5 h-100">
              <h4 class="font-weight-bold text-primary mb-4">Thông tin công ty</h4>
              <div class="mb-3"><strong>Tên công ty:</strong> {{ companyInfo.companyName }}</div>
              <div class="mb-3"><strong>Địa chỉ:</strong> {{ companyInfo.address }}</div>
              <div class="mb-3"><strong>Mã số thuế:</strong> {{ companyInfo.taxCode }}</div>
              <div class="mb-3"><strong>Điện thoại:</strong> {{ companyInfo.phone }}</div>
              <div class="mb-3"><strong>Email:</strong> {{ companyInfo.email }}</div>
              <div v-if="companyInfo.website"><strong>Website:</strong> {{ companyInfo.website }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-block pt-0">
      <div class="container">
        <section-title
          kicker="Năng lực &amp; dịch vụ"
          title="11 lĩnh vực hoạt động"
          description="Danh mục dịch vụ và vật tư chính mà Công ty TNHH NWM Việt Nam cung cấp."
        />
        <div class="row">
          <div
            v-for="(service, index) in services"
            :key="service._id || service.title"
            class="col-lg-4 col-md-6 mb-4"
          >
            <service-card
              :icon="service.icon"
              :title="service.title"
              :description="service.description"
              :category="service.category"
              :number="service.displayOrder || index + 1"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchServices } from "../../api/public";
import SectionTitle from "../../components/SectionTitle.vue";
import ServiceCard from "../../components/ServiceCard.vue";

export default {
  name: "AboutView",
  components: {
    SectionTitle,
    ServiceCard
  },
  data: function data() {
    return {
      services: []
    };
  },
  props: {
    companyInfo: {
      type: Object,
      default: function defaultCompanyInfo() {
        return {};
      }
    }
  },
  created: function created() {
    this.loadServices();
  },
  methods: {
    async loadServices() {
      const response = await fetchServices();
      this.services = response.data;
    }
  }
};
</script>
